import { SOGetOrganization } from '../organization/so-get-organization';


export class SOPutProject {

  constructor(
    public uid: string,
    public name: string = null,
    public description: string = null,
    public organization: SOGetOrganization = null,
  ) {
  }
  static construct(params: {[key: string]: any}) {
    return new SOPutProject(
      'uid' in params ? params.uid : null,
      'name' in params ? params.name : null,
      'description' in params ? params.description : null,
      'organization' in params ? params.organization : null,
    );
  }
}
